import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      modelContestBanner: {
        livejasmin: {
          dateTitle: {
            ...defineMessages({
              text: {
                id: 'pages.landing.modelContestBanner.livejasmin.dateTitle.text',
                defaultMessage: 'Starting {date}',
              },
            }),
          },
          prize: defineMessages({
            text: {
              id: 'pages.landing.modelContestBanner.livejasmin.prize.text',
              defaultMessage: 'Win {prize}',
            },
          }),
          description: {
            ...defineMessages({
              line2: {
                id: 'pages.landing.modelContestBanner.livejasmin.description.line2',
                defaultMessage: 'Join the biggest game ever.{br}Sign up now and change your life forever!',
              },
            }),
          },
          cta: {
            ...defineMessages({
              buttonText: {
                id: 'pages.landing.modelContestBanner.livejasmin.cta.buttonText',
                defaultMessage: 'Join now',
              },
            }),
          },
        },
      },
    },
  },
};
